import { Map } from 'immutable'
import { imageSizes } from './imageSizes'

export const getImageUrls = (fullImageUrl: string) =>
  Map(
    imageSizes.map((size) => {
      if (size === 'full') return [size, fullImageUrl]
      const splitUrl = fullImageUrl.split('/')
      const fileName = splitUrl[splitUrl.length - 1]
      const newFileName = fileName.replace('.', '_' + size + '.')
      const containerName = splitUrl[splitUrl.length - 2]
      const newContainerName = containerName + '-' + size
      const blobstorageUrl = splitUrl.splice(0, splitUrl.length - 2).join('/')
      const newUrl = blobstorageUrl + '/' + newContainerName + '/' + newFileName
      return [size, encodeURI(newUrl)]
    })
  )
